(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ap-pool-card-swatches"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.apPoolCardSwatchesReady) return;
    window.apPoolCardSwatchesReady = true;

    // Delegation also covers cards replaced by collection sorting/filtering.
    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const button = target && target.closest('button[data-pool-card-color]');
      if (!button) return;
      const card = button.closest('[data-pool-card]');
      if (!card) return;

      event.preventDefault();
      event.stopPropagation();

      card.querySelectorAll('button[data-pool-card-color]').forEach((item) => {
        item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
      });
      card.dataset.poolSelectedVariant = button.dataset.variantId;

      const image = card.querySelector('.ap-product-card__image');
      if (image && button.dataset.imageSrc) {
        image.srcset = button.dataset.imageSrcset || '';
        image.src = button.dataset.imageSrc;
        image.alt = button.dataset.imageAlt || '';
      }

      const price = card.querySelector('[data-pool-card-price]');
      if (price) price.textContent = button.dataset.priceLabel;
      const caption = card.querySelector('[data-pool-card-caption]');
      if (caption) caption.textContent = button.dataset.colorCaption;
      card.querySelectorAll('a[data-pool-card-link]').forEach((link) => {
        link.href = button.dataset.productUrl;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ap-scandi-card-swatches"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.apScandiCardSwatchesReady) return;
    window.apScandiCardSwatchesReady = true;

    // Delegation also covers cards replaced by collection sorting/filtering.
    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const button = target && target.closest('button[data-scandi-card-color]');
      if (!button) return;
      const card = button.closest('[data-scandi-card]');
      if (!card) return;

      event.preventDefault();
      event.stopPropagation();

      card.querySelectorAll('button[data-scandi-card-color]').forEach((item) => {
        item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
      });
      card.dataset.scandiSelectedVariant = button.dataset.variantId;

      const image = card.querySelector('.ap-product-card__image');
      if (image && button.dataset.imageSrc) {
        image.srcset = button.dataset.imageSrcset || '';
        image.src = button.dataset.imageSrc;
        image.alt = button.dataset.imageAlt || '';
      }

      const price = card.querySelector('[data-scandi-card-price]');
      if (price) price.textContent = button.dataset.priceLabel;
      const caption = card.querySelector('[data-scandi-card-caption]');
      if (caption) caption.textContent = button.dataset.colorCaption;
      card.querySelectorAll('a[data-scandi-card-link]').forEach((link) => {
        link.href = button.dataset.productUrl;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
